import { NgModule } from '@angular/core';

import { FormsModule } from './forms/forms.module';
import { PipesModule } from './pipes/pipes.module';
import { ServicesModule } from './services/services.module';
import { DirectivesModule } from './directives/directives.module';

/**
 * Commons module
 */
@NgModule({
	declarations: [
	],
	imports: [
		FormsModule,
		PipesModule,
		ServicesModule,
		DirectivesModule
	],
	exports: [
		FormsModule,
		PipesModule,
		ServicesModule,
		DirectivesModule
	],
	providers: [
	],

})
export class CommonsModule { }
